import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  // useNavigate,
} from "react-router-dom";
import { applyFavicon } from "./utils/favicon";
import Login from "./pages/login";
// import ForgetPassword from "./pages/forget-password";
// import SignUp from "./pages/sign-up";
import PrivateRoute from "./routers/private-router";
import Landing from "./pages/landing";
import Marketing from "./pages/marketing";
import Home from "./pages/home";
import NotFound from "./pages/not-found";
import { Toaster } from "react-hot-toast";
// import { useEffect } from "react";
// import Lenis from "lenis";
import "lenis/dist/lenis.css";
import PrivacyPolicy from "./pages/privacy-policy";
import TermsAndConditions from "./pages/terms-and-conditions";
import ContactUs from "./pages/contact-us";
import AdminTools from "./pages/admin-tools";
import AdminCheckout from "./pages/admin-checkout";
import AdminCheckoutV2 from "./pages/admin-checkout-v2";
import AdminCheckoutV2Orders from "./pages/admin-checkout-v2-orders";
import GlobalWebsiteDisclaimer from "./pages/global-website-disclaimer";

/* Repaints the tab icon whenever the route changes: amber under /admin/*,
   brand blue everywhere else. Has to live INSIDE <Router> — useLocation reads
   from the router context, so calling it up in App() would throw.
   Renders nothing; it exists purely for the effect. */
function FaviconSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    applyFavicon(pathname);
  }, [pathname]);
  return null;
}

function App() {
  // new Lenis({
  //   autoRaf: true,
  // });

  return (
    <>
      <Router>
        <FaviconSync />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/global-website-disclaimer" element={<GlobalWebsiteDisclaimer />} />
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/admin/tools" element={<AdminTools />} />
          </Route>
          {/* Outside PrivateRoute on purpose: the admin key is the only
              credential this page asks for, so the marketing team can edit the
              offer without a Firebase account. Its own passphrase gate and the
              signed token on every callable still guard the data. */}
          <Route path="/admin/checkout" element={<AdminCheckout />} />
          {/* The multi-region editor. A separate route rather than a mode of
              the one above, so /checkout/ keeps an admin that cannot be broken
              by v2 work while both are live. Same passphrase gate, same
              reasoning about PrivateRoute. */}
          <Route path="/admin/checkout-v2" element={<AdminCheckoutV2 />} />
          {/* Orders with what each payment cost. Its own route rather than a
              tab on the editor above: the editor holds unpublished form state
              and a refresh here reloads Firestore, so mixing the two would put
              a "discard your edits?" between a price and a revenue check. */}
          <Route
            path="/admin/checkout-v2-orders"
            element={<AdminCheckoutV2Orders />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <Toaster position="bottom-right" />
    </>
  );
}

export default App;
